// Erbjudanden (Offers) – speglar backendmodellen.

export const OfferChannelTypes = ["cart", "receipt", "mypages"] as const;
export type OfferChannelType = typeof OfferChannelTypes[number];

export const OfferEligibilityImplementations = ["cart_contains", "has_bought", "start_group"] as const;
export type OfferEligibilityImplementation = typeof OfferEligibilityImplementations[number];

export const OfferGenders = ["women", "men", "both"] as const;
export type OfferGender = typeof OfferGenders[number];

export const OfferRewardTypes = ["buy_product", "external_link"] as const;
export type OfferRewardType = typeof OfferRewardTypes[number];

export interface OfferChannel {
    id?: string;
    channel: OfferChannelType;
    isActive: boolean;
    activeFrom?: string;
    activeTo?: string;
    title: string;
    titleEn: string;
    shortDescription: string;
    shortDescriptionEn: string;
    longDescription: string;
    longDescriptionEn: string;
    heroImageUrl: string;
    buttonText: string;
    buttonTextEn: string;
    sortIndex?: number;
}

export interface OfferEligibilityProduct {
    id?: string;
    productId: string;
    productVariantId?: string;
    startGroupId?: string;
}

export interface OfferReward {
    id?: string;
    rewardType: OfferRewardType;
    productId: string;
    productVariantId?: string;
    // Används för rewardType "external_link":
    url?: string;
    linkText?: string;
    linkTextEn?: string;
}

export interface Offer {
    id: string;
    name: string;
    isArchived: boolean;
    eligibilityImplementation: OfferEligibilityImplementation;
    eligibilityGender: OfferGender;
    hideIfRewardPurchased: boolean;
    channels: OfferChannel[];
    eligibilityProducts: OfferEligibilityProduct[];
    rewards: OfferReward[];
    created?: string;
    createdBy?: string;
    updated?: string;
    updatedBy?: string;
}

// UI-etiketter
export const OFFER_CHANNEL_LABELS: { [k in OfferChannelType]: string } = {
    cart: "Varukorgen",
    receipt: "Kvitto efter betalning",
    mypages: "Mina sidor",
};

export const OFFER_IMPLEMENTATION_LABELS: { [k in OfferEligibilityImplementation]: string } = {
    cart_contains: "Varukorgen innehåller",
    has_bought: "Har köpt produkt",
    start_group: "Anmäld till startled",
};

export const OFFER_GENDER_LABELS: { [k in OfferGender]: string } = {
    women: "Enbart tjejer",
    men: "Enbart killar",
    both: "Båda könen",
};

export const OFFER_REWARD_LABELS: { [k in OfferRewardType]: string } = {
    buy_product: "Köp produkt",
    external_link: "Länk till extern produkt",
};
